<template>
<div>
      
      <div class="block block-bordered">
        <div class="block block-themed">
          <div class="block-header bg-muted">
                  <ul  class="block-options">

                      <li v-if="flagDisplaySharing===0">
                          <button type="button" @click="toggleDisplaySharing()"><i class="fa fa-angle-double-down fa-2x"></i></button>
                      </li>

                      <li v-if="flagDisplaySharing">
                          <button  type="button" @click="toggleDisplaySharing()"><i class="fa fa-angle-double-up fa-2x"></i></button>
                      </li>

                  </ul>
              <h2 class="block-title" @click="toggleDisplaySharing()"><i class="fa fa-share-alt fa-1x push-5-r "></i>{{ blocLabelSharingList[actualLanguage] }}</h2>
          </div>

          <div v-if="flagDisplaySharing" class="block-content">
            <div class="row">
                <div class="table-responsive">
                <table v-if="ListOfSharings.length>0" class="table">
                    <thead>
                        <tr>
                            <th class="text-center" style="width: 10%;">{{ tableTitleType[actualLanguage] }}</th>
                            <th class="text-center" style="width: 25%;">{{ tableTitleReferenceName[actualLanguage] }}</th>
                            <th class="text-center" style="width: 20%;">{{ tableTitleSharingName[actualLanguage] }}</th>
                            <th class="text-center" style="width: 20%;">{{ tableTitleRecipient[actualLanguage] }}</th>
                            <th class="text-center" style="width: 10%;">{{ tableTitleStatus[actualLanguage] }}</th>
                            <th class="text-center" style="width: 15%;">{{ tableTitleAction[actualLanguage] }}</th>
                        </tr>
                    </thead>
                    <tbody>   
                          <tr v-for="(sharing,index) in ListOfSharings">
                              <td v-if="sharing.sharedEntity.entityType==sharingListData.sharingType" class="text-center">
                                <i v-if ="sharing.sharedEntity.entityType==='Channel'" class="fa fa-television fa-2x push-5-r "></i>
                                <i v-if ="sharing.sharedEntity.entityType==='Device'" class="fa fa-server fa-2x push-5-r "></i>
                                <i v-if ="sharing.sharedEntity.entityType==='Bundle'" class="fa fa-usb fa-2x push-5-r "></i>
                                <i v-if ="sharing.sharedEntity.entityType==='Group'" class="fa fa-users fa-2x push-5-r "></i>
                                <i v-if ="sharing.sharedEntity.entityType==='Car'" class="fa fa-car fa-2x push-5-r "></i>
                                
                              </td>
                              <td v-if="sharing.sharedEntity.entityType==sharingListData.sharingType" class="text-center">
                                <p>{{sharing.sharedEntity.entityReferenceName}}</p>
                              </td>
                              <td v-if="sharing.sharedEntity.entityType==sharingListData.sharingType" class="text-center">
                                  <p>{{sharing.sharingReferenceName}}</p>
                              </td>
                              <td v-if="sharing.sharedEntity.entityType==sharingListData.sharingType" class="text-center">
                                  <p>{{sharing.guessEmail}}</p>
                              </td>
                              <td v-if="sharing.sharedEntity.entityType==sharingListData.sharingType" class="text-center">
                                  <button v-if= "sharing.sharingStatus=='Activated'" type="button" class="btn btn-xs btn-success" name="button">{{ tableStatusActivated[actualLanguage] }}</button>
                                  <button v-if= "sharing.sharingStatus=='Rejected'" type="button" class="btn btn-xs btn-danger" name="button">{{ tableStatusRejected[actualLanguage] }}</button>
                                  <button v-if= "sharing.sharingStatus=='Pending'" type="button" class="btn btn-xs btn-info" name="button">{{ tableStatusOnHold[actualLanguage] }}</button>
                                  <button v-if= "sharing.sharingStatus=='OnHold'" type="button" class="btn btn-xs btn-warning" name="button">Pause</button>
                              </td>
                              <td v-if="sharing.sharedEntity.entityType==sharingListData.sharingType" class="text-center">
                                  <div v-if="bundleConfigEditFlag" class="btn-group">
                                      <button class="btn btn-xs btn-default" type="button" @click="editSharingRulePermissions(index)" data-toggle="tooltip" title="Modifier/Edit"><i class="fa fa-pencil"></i></button>
                                      <button v-if= "sharing.sharingStatus=='Activated'" class="btn btn-xs btn-default" type="button" @click="saveSharingStatus(index,'OnHold')" data-toggle="tooltip" title="Pause"><i class="fa fa-pause"></i></button>
                                      <button v-if= "sharing.sharingStatus=='OnHold'" class="btn btn-xs btn-default" type="button" @click="saveSharingStatus(index,'Activated')" data-toggle="tooltip" title="Activer/Enable"><i class="fa fa-play"></i></button>
                                      <button class="btn btn-xs btn-default" type="button" @click="deleteSharing(index)" data-toggle="tooltip" title="Supprimer/Delete"><i class="fa fa-trash"></i></button>
                                  </div>
                              </td>
                          </tr>
                    </tbody>
                </table>
                </div>


            </div>

          </div>
        </div>
      </div>
      

</div>

</template>

<script>

import _ from 'underscore'
import {mapState, mapActions,mapGetters} from 'vuex'
import Spinner from '../../../components/Spinner.vue'


export default {
  props: ['sharingListData'],
  components: {
    Spinner,
  },
  data() {
    return {    
      actualLanguage : "FR",
      flagDisplaySharing: 0,

      ListOfSharings:[], 

      bundleConfigViewFlag : false,
      bundleConfigEditFlag : false,
      bundleConfigDeleteFlag : false,
      bundleSharingEnableFlag : false,

      blocLabelSharingList: {FR: "Liste des partages", EN: 'Sharings list'},
      tableTitleType : {FR: "Type", EN: 'Type'},
      tableTitleReferenceName : {FR: "Nom de référence", EN: 'Reference name'},
      tableTitleSharingName : {FR: "Nom du partage", EN: 'Sharing name'},
      tableTitleRecipient : {FR: "Destinataire", EN: 'Recipient'},
      tableTitleStatus : {FR: "Statut", EN: 'Status'},
      tableTitleAction : {FR: "Action", EN: 'Action'},
      tableStatusActivated : {FR: "Activé", EN: 'Activated'},
      tableStatusRejected : {FR: "Refusé", EN: 'Rejected'},
      tableStatusOnHold : {FR: "Attente", EN: 'On hold'},

    }
  },


  computed: {
    ...mapState('sessionStore', ['profileData','displayAdminFlag','groupArborescence','actualGroup','actualBundle']),
  },


  methods: {
    ...mapActions('overlayStore', ['showModal']),

   toggleDisplaySharing(){
      this.readGroupSharings()
      this.flagDisplaySharing = ~this.flagDisplaySharing
    },


    readGroupSharings(){
      if (this.sharingListData.sharingType == 'Group'){
        var requestData = {'postAction':'GetRuleForEntity','EntityToRead':this.actualGroup.group_id}
      }else{
        var requestData = {'postAction':'GetRuleForEntity','EntityToRead':this.actualBundle.bundle_id}
      }
      
      this.$store.dispatch('sessionStore/postRule', requestData)
          .then((response) => {
          if(response.data.Code=='OK'){
              this.ListOfSharings = response.data.Data
              }else{ window.alert(response.data.Message[this.actualLanguage])}
          })
    },


    editSharingRulePermissions(sharingIndex){
      var modalParameters = {'ruleId':this.ListOfSharings[sharingIndex].ruleId,
                        'referenceId':this.ListOfSharings[sharingIndex].referenceId,
                        'sharingReferenceName':this.ListOfSharings[sharingIndex].sharingReferenceName,
                        'sharingGuessEmail':this.ListOfSharings[sharingIndex].guessEmail,
                        }

      this.$store.dispatch('overlayStore/setParameters',modalParameters)
      this.showModal('edit-access-rules-form')
    },



    saveSharingStatus(sharingIndex,newStatus) {
        var requestData = { 'postAction':'SaveSingleRuleStatus',
                            'ruleId': this.ListOfSharings[sharingIndex].ruleId,
                            'referenceId': this.ListOfSharings[sharingIndex].referenceId,
                            'newStatus': newStatus,
                            }

        this.$store.dispatch('sessionStore/postRule', requestData)
            .then((response) => {
            if(response.data.Code=='OK'){
                  window.alert(response.data.Message[this.actualLanguage])
                  this.readGroupSharings()
                }
                else{ 
                  window.alert(response.data.Message[this.actualLanguage])}
            })       
      
    },


    deleteSharing(sharingIndex){
        if (this.actualLanguage == "FR"){
          var confirmation = prompt("Supprimer le partage : "+this.ListOfSharings[sharingIndex].sharingReferenceName, "Confirmer en écrivant : DELETE");
        }else{
          var confirmation = prompt("Delete the sharing : "+this.ListOfSharings[sharingIndex].sharingReferenceName, "Confirm by writing : DELETE");
        }
        if(confirmation == 'DELETE'){
            var requestData = { 'postAction':'DeleteSingleRule',
                                'ruleId': this.ListOfSharings[sharingIndex].ruleId,
                                'referenceId': this.ListOfSharings[sharingIndex].referenceId,
                                }

            this.$store.dispatch('sessionStore/postRule', requestData)
                .then((response) => {
                if(response.data.Code=='OK'){
                      window.alert(response.data.PromptMessage[this.actualLanguage])
                      this.readGroupSharings()
                    }
                    else{ 
                      window.alert(response.data.PromptMessage[this.actualLanguage])}
                }) 
            }    
    },


    findPermissionItemValue(permissionList,idToFind){
        var value = false
        for (var n = 0; n < permissionList.length; n++){
          if(permissionList[n].id == idToFind)
          {value = permissionList[n].value}
        }
        return value
    },    


  },

  mounted() {
    //Retirer l'inversion puisque le composant PortGraph effectue l'inversion sur la variable 
    //console.log(this.sharingListData.sharingType)

    if(localStorage.language){this.actualLanguage =  localStorage.language}
      else{this.actualLanguage = 'FR'}

    if(this.sharingListData.sharingType == 'Group'){
      this.bundleConfigViewFlag = true
      this.bundleConfigEditFlag = true
      this.bundleConfigDeleteFlag = true
      this.bundleSharingEnableFlag = true
    }else{
      this.bundleConfigViewFlag = this.findPermissionItemValue(this.actualBundle.permissions.bundle,'bundleConfigView')
      this.bundleConfigEditFlag = this.findPermissionItemValue(this.actualBundle.permissions.bundle,'bundleConfigEdit')
      this.bundleConfigDeleteFlag = this.findPermissionItemValue(this.actualBundle.permissions.bundle,'bundleConfigDelete')
      this.bundleSharingEnableFlag = this.findPermissionItemValue(this.actualBundle.permissions.bundle,'bundleSharingEnable')
    }


  },




}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// ConfigSharingList.vue?bbaadc44